import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import { showConfirmAlert } from "../components-react/ReactAlert";
import SelectDropdown from "../components-react/SelectDropdown";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../data/APIs";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";

const GymAliasForm = ({
  userInfoData,
  rowData,
  isEdit,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const { postPutLoading } = useSelector((state) => state.common);

  const forminitials = {
    selectedGym:
      isEdit && rowData?.gym_id && rowData?.gym_name
        ? {
            label: rowData.gym_name,
            value: rowData.gym_id,
          }
        : "",
    aliasName:
      isEdit && (rowData?.alias_name || rowData?.alias)
        ? rowData.alias_name || rowData.alias
        : "",
    isActive: isEdit ? (rowData?.status === "active" ? true : false) : true,
    isPT: isEdit ? (rowData?.is_pt ? true : false) : false,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    setIsSubmit(false);

    setFormValues((prevs) => ({
      ...prevs,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeDropdown = (name, value) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = (formValues) => {
    let errors = {};

    if (!formValues.selectedGym) {
      errors.selectedGym = "Gym selection is required!";
    }

    if (!formValues.aliasName) {
      errors.aliasName = "Alias name is required!";
    } else if (formValues.aliasName.length > 100) {
      errors.aliasName = "Alias name cannot exceed 100 characters!";
    }

    return errors;
  };

  const onSubmit = () => {
    const errors = validateForm(formValues);
    setFormErrors(errors);
    setIsSubmit(true);
  };

  const handleSubmitForm = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = "/gym/alias";
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setFormValues(forminitials);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    dispatch(fetchGymData(userInfoData?.token));
  }, []);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      let userData = {
        gym_id: formValues.selectedGym?.value || "",
        alias: formValues.aliasName || "",
        status: formValues.isActive?.value ? "active" : "inactive",
        is_pt: formValues.isPT ? 1 : 0,
      };

      if (isEdit) {
        userData.uid = rowData?.uid || "";
      }

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Confirm Before Submitting!`,
        `No`,
        "Submit"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <CommonHeadingNBtns
        title={`${isEdit ? "Update" : "Add"} Gym Alias`}
        btnTxt="Submit"
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />

      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="selectedGym" className="formInputLabel">
              Select Gym <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper no-border ${
                formErrors?.selectedGym ? "formError" : ""
              }`}
            >
              <SelectDropdown
                options={gymData?.length > 0 ? gymData : []}
                selectedOption={formValues.selectedGym}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedGym", selectedValue)
                }
                name="Gym"
                placeholder="Select a gym..."
              />
            </div>
            {formErrors?.selectedGym && (
              <span className="error-message">{formErrors.selectedGym}</span>
            )}
          </div>

          <div className="formInputBox">
            <label htmlFor="aliasName" className="formInputLabel">
              Alias Name <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter alias name"
              className={`formInput ${
                formErrors?.aliasName ? "formError" : ""
              }`}
              name="aliasName"
              value={formValues.aliasName}
              onChange={onChangeInput}
              maxLength={100}
            />
            {formErrors?.aliasName && (
              <span className="error-message">{formErrors.aliasName}</span>
            )}
          </div>

          <div className={`commonWrapper commonSwitchWrapper no-border span2`}>
            <Form.Check
              type="switch"
              name="isActive"
              label={`${formValues.isActive ? "Active" : "Inactive"} ${
                formErrors?.isActive ? "formError" : ""
              }`}
              checked={formValues.isActive}
              onChange={onChangeInput}
            />

            <Form.Check
              type="switch"
              name="isPT"
              label={`${formValues.isPT ? "PT" : "Non PT"}`}
              checked={formValues.isPT}
              onChange={onChangeInput}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default GymAliasForm;
